module.exports = __webpack_public_path__ + "static/media/Game Dev Meet-Up.284e13f1.png";